import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
	createPersistedState({
		paths: [ 'userLogin.userLoginData' ],
		storage: window.localStorage,
	})(store);
};
